/* ── SNKRS Extra Gallery Carousel ── */
(function () {
  'use strict';

  function initExtraGallery(container) {
    const track = container.querySelector('.snkrs-xgallery__track');
    const slides = container.querySelectorAll('.snkrs-xgallery__slide');
    const btnPrev = container.querySelector('.snkrs-xgallery__btn--prev');
    const btnNext = container.querySelector('.snkrs-xgallery__btn--next');
    const dots = container.querySelectorAll('.snkrs-xgallery__dot');
    const counter = container.querySelector('.snkrs-xgallery__counter');

    if (!track || slides.length === 0) return;

    let current = 0;
    const total = slides.length;

    // Touch/drag state
    let startX = 0;
    let isDragging = false;

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      current = index;
      track.style.transform = `translateX(-${current * 100}%)`;

      // Dots
      dots.forEach((d, i) => d.classList.toggle('active', i === current));

      // Counter
      if (counter) counter.textContent = `${current + 1} / ${total}`;

      // Buttons
      if (btnPrev) btnPrev.disabled = current === 0;
      if (btnNext) btnNext.disabled = current === total - 1;
    }

    // Arrow clicks
    if (btnPrev) btnPrev.addEventListener('click', () => goTo(current - 1));
    if (btnNext) btnNext.addEventListener('click', () => goTo(current + 1));

    // Dot clicks
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    // Touch support
    container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    container.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
      isDragging = false;
    }, { passive: true });

    // Mouse drag support
    container.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isDragging = true;
      e.preventDefault();
    });

    window.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
      isDragging = false;
    });

    // Keyboard support
    container.setAttribute('tabindex', '0');
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Init
    goTo(0);
  }

  function init() {
    document.querySelectorAll('.snkrs-xgallery').forEach(initExtraGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();